/*
 * Het adres dat we klanten noemen. Tablets die al gekoppeld waren draaien nog
 * op het oude adres (de koppeling hoort bij dat adres); ze tonen toch dit.
 */
export const HOOFDADRES = 'tw1club.com'
